import { render, staticRenderFns } from "./PostDetails.vue?vue&type=template&id=7daa7606&scoped=true&"
import script from "./PostDetails.vue?vue&type=script&lang=js&"
export * from "./PostDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7daa7606",
  null
  
)

export default component.exports